import CouvertModal from './CouvertModal';

export default CouvertModal;
